import { useSelector } from "react-redux";

import { ComponentMyParking } from "@components";
import { selectAuth } from "@redux";


export const PageMyParking = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentMyParking
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
